// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"300":"f949949d","479":"c682fc6e","607":"942d582f","765":"f949949d","980":"3af6c6a7"}[chunkId] + ".css";
};